import isPast from 'date-fns/is_past';
import {getPickTimestamp} from 'components/Cards/Pick/helpers';
import {addFavoritePickRequest, removeFavoritePickRequest} from '../requests';

export const SET_FAVORITE_PICKS = 'SET_FAVORITE_PICKS';
export const ADD_FAVORITE_PICK = 'ADD_FAVORITE_PICK';
export const REMOVE_FAVORITE_PICK = 'REMOVE_FAVORITE_PICK';

export const setFavoritePicks = picks => ({
  type: SET_FAVORITE_PICKS,
  payload: picks,
});

export const addFavorite = ({odds, odd, event, pick, createdAt, id}) => dispatch => {
  const time = getPickTimestamp(event);

  if (isPast(time)) {
    alert('Only not started events can be added to favorites');
  } else {
    dispatch({
      type: ADD_FAVORITE_PICK,
      payload: {
        event,
        pick,
        createdAt,
        id,
        odds: odds || odd,
        status: 'pending',
        result: 'pending',
      },
    });
    addFavoritePickRequest({
      pick,
      eventId: event.id,
    });
  }
};

export const removeFavorite = pickId => dispatch => {
  if (window.confirm('Are you sure you want to remove favorite pick?')) {
    dispatch({
      type: REMOVE_FAVORITE_PICK,
      payload: pickId,
    });
    removeFavoritePickRequest(pickId);
  }
};
